/**
 * Log an Adobe Analytics event
 * If a 'newPage' event replace global.pageData with a new empty object before logging
 * For more detail see docs/analytics.md
 *
 * @param {string} eventName
 * @param {object} event payload
 */
declare let global: { pageData: any; pageDataTracker: any };

const track = (eventName: string, payload: Payload) => {
  if (eventName === "newPage") {
    global.pageData = {};
  }

  const tracker = global.pageDataTracker;

  if (tracker) {
    tracker.trackEvent(eventName, payload);
  }
};

const generateNewPageData = (
  pageName: string,
  { ManuscriptTitle, JournalAcronym, DocumentId, LatestRevisionNumber } : SubmissionDetails
) => ({
  page: {
    type: "CP-CA",
    name: pageName,
    productName: "sch",
    businessUnit: "els:rp:st",
    language: "en",
  },
  content: [
    {
      id: `sch:manuscript:id:${JournalAcronym + "-" + DocumentId + "." + LatestRevisionNumber}`,
      type: "sch:manuscript",
      format: "MIME-HTML",
      title: ManuscriptTitle,
    },
  ],
  visitor: {
    accessType: "sch:ANON_GUEST",
  },
});

const generateNewPageError = (pageName: string, errMessage: string) => ({
  page: {
    type: "CP-CA",
    name: pageName,
    productName: "sch",
    businessUnit: "els:rp:st",
    language: "en",
  },
  form: {
    errorType: errMessage,
  },
});

type trackLinkOutSubmissionDetailsParameter = {JournalAcronym: string | null, DocumentId: number | null, LatestRevisionNumber: number | null} | Record<string,never>

const trackLinkOut = (
  { JournalAcronym = null, DocumentId = null, LatestRevisionNumber = null } : trackLinkOutSubmissionDetailsParameter,
  link : string
) =>
  track("linkOut", {
    content: [
      {
        id: `sch:manuscript:id:${JournalAcronym + "-" + DocumentId + "." + LatestRevisionNumber}`,
        linkOut: "elsevier:service.elsevier.com",
      },
    ],
    link: {
      name: "Contact Journal Article Publishing Support Center",
      type: "exit",
      destination: link,
    },
  });

export { track, generateNewPageData, generateNewPageError, trackLinkOut };
